import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { ScrollToTop } from './components/layout/scrollTop/scrollToTop'

import Main from './containers/main'
import MakeClaimmbFinanceCheck from './containers/makeClaimMbFinanceCheck'
import SignDocuments from './containers/signDocuments'

export default function AppRouter() {
    return (
        <Router>
            <ScrollToTop />
            <Routes>
                <Route path="/" element={<Main />}>
                    <Route path="/" element={<MakeClaimmbFinanceCheck />} />
                    <Route path="/sign/:token" element={<SignDocuments />} />
                </Route>
            </Routes>
        </Router>
    )
}
